module.exports = __webpack_public_path__ + "static/media/espiga_esponja.76f49c43.png";